import { StoreApi } from 'zustand'

const updateLiveStore =
  <T>(storeApi: StoreApi<T>) =>
  (store: T): T => {
    storeApi.setState(store)
    return storeApi.getState()
  }

export const StoreUtils = {
  updateLiveStore,
}
